import { FC } from "react";
import { ChequeActivityDataWithMeta, ChequeActivityDelete } from "../types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { addComma } from "../../../../utils";

const ChequeDeleteActivity: FC<ChequeActivityDataWithMeta> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as ChequeActivityDelete;
  return (
    <>
      <ActivityTitle type={type}>حذف چک</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="شماره چک"
          value={activity_.number}
        />
        <ActivityBodyInfo
          type={type}
          title="مبلغ"
          value={addComma(activity_.price)}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default ChequeDeleteActivity;
